import { Routes, Route, BrowserRouter, HashRouter } from 'react-router-dom';
import MainPage from './pages/MainPage';
import '@arco-design/web-react/dist/css/arco.css';
import LoginPage from '@/pages/LoginPage';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { BackgroundProvider } from './context/BackgroundContext';
import { AppContentProvider } from '@/context/AppContent';

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const roleId = urlParams.get('roleId');
  if (roleId) {
    sessionStorage.setItem('check-role-id', roleId);
  }

  return (
    <HashRouter>
      <AppContentProvider>
        <AuthProvider>
          <BackgroundProvider>
            <Routes>
              <Route path="/">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <MainPage />
                    </ProtectedRoute>
                  }
                />
                <Route path="/login" element={<LoginPage />} />
                <Route
                  path="/*"
                  element={
                    <ProtectedRoute>
                      <MainPage />
                    </ProtectedRoute>
                  }
                />
              </Route>
            </Routes>
          </BackgroundProvider>
        </AuthProvider>
      </AppContentProvider>
    </HashRouter>
  );
}

export default App;
